import React, { useState } from 'react';
import { Send } from 'lucide-react';

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  isLoading: boolean;
  placeholder?: string;
}

export const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, isLoading, placeholder = 'Digite sua mensagem...' }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim() && !isLoading) {
      onSendMessage(message);
      setMessage('');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex space-x-2">
      <input
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder={placeholder}
        className="input-primary flex-1"
        disabled={isLoading}
      />
      <button
        type="submit"
        className="p-2 bg-purple-500 rounded-lg text-white hover:bg-purple-600 transition-colors disabled:opacity-50"
        disabled={isLoading || !message.trim()}
      >
        <Send className="w-6 h-6" />
      </button>
    </form>
  );
};